import React from 'react';
import {Button, Card, Col, Form, Icon, Input, message, Modal, Row, Tooltip} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import LinesEllipsis from 'react-lines-ellipsis';
import {patchEventGuests} from "../../services/evt";
import CkUpload from "../../components/CkUpload";


const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewGuestForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formLoading: false
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }


    resetFormFields = () => {
        this.props.form.resetFields();
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;

                //去除_开头的属性(为了动态字段添加的)
                var _values = {...values};
                Object.keys(_values).forEach((key) => {
                    if (key != "__self__" && key.startsWith("_")) {
                        delete _values[key]
                    }
                })

                if (JSON.stringify(_values) === "{}") {
                    _values.__self__ = [];
                }
                _values.__self__.forEach((obj,index)=>{
                    obj.seq=index;
                })
                patchEventGuests(Object.assign({eventId: this.props.evt.header.id}, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }

    addField = (fieldName, index) => {
        const {form} = this.props;
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        _fieldVal = _fieldVal.concat(1);
        const sVal = {};
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    removeField = (fieldName, index) => {
        const {form} = this.props;
        let fieldVal = form.getFieldValue(fieldName);
        let _fieldVal = form.getFieldValue(`_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        const sVal = {};
        sVal[fieldName] = fieldVal;
        sVal[`_${fieldName}`] = _fieldVal;
        form.setFieldsValue(sVal);
    }

    //移动
    moveQuestionsItem = (fieldName,index,type) =>{
        const {setFieldsValue,getFieldsValue} = this.props.form;
        let fieldsValue  = getFieldsValue();
        let columns  = fieldsValue[`_${fieldName}`];
        let columns1  = fieldsValue[fieldName];
        let from =index;
        let to =type == 'up' ? index-1 : index+1;
        // if (from < to) to--;

        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        setFieldsValue(fieldsValue);
    }


    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    render() {
        const evt = this.props.evt;

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        getFieldDecorator('___self__', {initialValue: evt.guests.map(g=>g)});
        const guests = getFieldValue('___self__') ? getFieldValue('___self__') : [];

        const guestComp =
            <Row gutter={12} className="form-item-guest-comp">
                {guests.map((c, index) => {
                    return (
                        <Col span={24} key={`guest${index}`}>
                            <Card bodyStyle={{padding: "12px 12px 12px 0"}} style={{border: "none"}}>
                                <div className="form-item-guest-contain">
                                    <div className="form-item-guest-avatar-contain">

                                        <div style={{display: "none"}}>
                                            {getFieldDecorator(`__self__[${index}].id`, {
                                                initialValue: c.id,
                                                rules: [{required: false}],
                                            })(
                                                <Input/>
                                            )}
                                            {getFieldDecorator(`__self__[${index}].groupId`, {
                                                initialValue: c.groupId ? c.groupId : '',
                                                rules: [{required: false}],
                                            })(
                                                <Input/>
                                            )}
                                        </div>

                                        {getFieldDecorator(`__self__[${index}].avatarUrl`, {
                                            initialValue: c.avatarUrl,
                                            getValueFromEvent: (fileUrlObj) => {
                                                return fileUrlObj.url;
                                            }
                                        })(
                                            <CkUpload
                                                width={130}
                                                height={130}
                                            />
                                        )}

                                         <span style={{color:'#959595'}}>建议200*200像素的图片</span>
                                    </div>
                                    <div className="form-item-guest-content-contain">
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].name`, {
                                                initialValue: c.name,
                                                rules: [{required: true, whitespace: true},{whitespace:true, message: '不能输入空格!'},{min: 1, max: 100, message: '长度限制为1至100个之间!'}],
                                            })(
                                                <Input placeholder="嘉宾名称,如：小米科技：雷军"/>
                                            )}
                                        </Form.Item>
                                        <Form.Item hasFeedback help="">
                                            {getFieldDecorator(`__self__[${index}].introduction`, {
                                                initialValue: c.introduction,
                                                rules: [{required: true, whitespace: true},{whitespace:true, message: '不能输入空格!'},{min: 2, max: 500, message: '长度限制为2至500个之间!'}],
                                            })(
                                                <Input.TextArea autosize={{minRows: 4}} placeholder="嘉宾介绍，如：现任第十三届全国人大代表，全国工商联副主席，北京市工商联副主席，小米科技有限责任公司董事长兼首席执行官，北京金山软件有限公司董事长。 2017十大经济年度人物。"/>
                                            )}
                                        </Form.Item>
                                    </div>
                                    <a href="#" className="card-ck-contain-remove" onClick={() => this.removeField("__self__", index)}>
                                        <div><Icon type="delete"/>删除</div>
                                    </a>
                                    <div className='card-ck-contain-move'>
                                        <a onClick={()=>this.moveQuestionsItem('__self__',index,'up')} style={{opacity:index==0 && 0}}>上移</a>
                                        <a onClick={()=>this.moveQuestionsItem('__self__',index,'down')} style={{opacity:index==(guests.length-1) && 0}}>下移</a>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    )
                })}
                <Col span={3}>
                    <Card bodyStyle={{padding: "12px"}} style={{border: "none"}}>
                        <a className="card-ck-contain-add" onClick={() => this.addField("__self__")}> <Icon type="plus"/> </a>
                    </Card>
                </Col>
            </Row>


        return (
            <Form>
                <Row gutter={12} className="guest-comp">
                    {evt.guests.map((guest, index) => {
                        return (
                            <Col span={12} key={`guest${index}`}>
                                <Card bodyStyle={{padding: "12px"}}>
                                    <div className="guest-contain">
                                        <div className="guest-avatar-contain">
                                            <img src={guest.avatarUrl} style={{width: 87, height: 87}}/>
                                        </div>

                                        <div className="guest-content-contain">
                                            <div className="guest-content-name">{guest.name}</div>
                                            <Tooltip placement="rightTop" mouseEnterDelay={0.3} title={guest.introduction}>
                                                <div className="guest-content-introduction">
                                                    <LinesEllipsis
                                                        text={guest.introduction}
                                                        maxLine='4'
                                                        ellipsis='...'
                                                        trimRight
                                                        basedOn='words'
                                                    />
                                                </div>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>

                <Modal
                    visible={this.props.editable}
                    title="编辑嘉宾"
                    width="880px"
                    maskClosable={false}
                    afterClose={() => this.resetFormFields()}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >

                    {guestComp}


                </Modal>
            </Form>
        )
    }
}


EvtViewGuestForm.contextTypes = {}

EvtViewGuestForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "guestEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewGuestForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewGuestForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewGuestForm.jsx